import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import loginBoxBg from '../images/bg.jpg';
import HeaderOnlyLogo from '../layout/HeaderOnlyLogo';

export default function PasswordReset() {

  return (

    
    <section className='page-sign-in' style={{ backgroundImage: `url(${loginBoxBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
      <HeaderOnlyLogo />
      <div className='sign-in-form w-full'>
        <div className='form-card-container'>
          <div className='form-header'>
            <h2 className='form-title'>Reset Password</h2>
            <div className='form-description'>Enter your email to reset password</div>
          </div>
          <div className='form-body'>
            <form>
              <div className='form-group'>
                <label htmlFor='email' className='form-lbl'>Email</label>
                <input type='email' id='email' name='email' placeholder='email@email.com' />
              </div>
              <div className='form-group'>
                <button type='submit' className='btn-sign-in'>
                  <span>Continue</span>
                  <svg width="15" height="8" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.85124 0.408704V3.36379H0.640554C0.470669 3.36379 0.307742 3.43128 0.187614 3.55141C0.0674873 3.67153 0 3.83446 0 4.00435C0 4.17423 0.0674873 4.33716 0.187614 4.45729C0.307742 4.57741 0.470669 4.6449 0.640554 4.6449H9.85124V7.59145C9.85029 7.67204 9.87362 7.75105 9.9182 7.81819C9.96278 7.88534 10.0265 7.93751 10.1012 7.96792C10.1758 7.99833 10.2579 8.00557 10.3367 7.98869C10.4155 7.97181 10.4874 7.9316 10.543 7.87329L14.8801 4.28619C14.9181 4.24884 14.9482 4.2043 14.9688 4.15518C14.9894 4.10606 15 4.05333 15 4.00008C15 3.94682 14.9894 3.89409 14.9688 3.84497C14.9482 3.79585 14.9181 3.75132 14.8801 3.71396L10.543 0.12686C10.4874 0.0685509 10.4155 0.0283417 10.3367 0.0114641C10.2579 -0.00541361 10.1758 0.00182222 10.1012 0.0322308C10.0265 0.0626394 9.96278 0.114812 9.9182 0.181958C9.87362 0.249104 9.85029 0.328113 9.85124 0.408704Z" fill="white"/>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
